import { render } from "./TextDescription.vue?vue&type=template&id=0bbf5aa3"
import script from "./TextDescription.vue?vue&type=script&lang=ts"
export * from "./TextDescription.vue?vue&type=script&lang=ts"
script.render = render

export default script